'use client';

import { Block, BlockKey } from '../factories/types';
import { LivePreviewWrapper } from './LivePreviewWrapper';

/** Live preview which requires no mock behavior, and can just render the underlying component */
export const BasicLivePreview = <key extends BlockKey, Ctx extends {} = {}>(BlockComponent: Block<key, Ctx>) =>
	({ data, ...props }: Parameters<Block<key, Ctx>>[0]) =>
		<LivePreviewWrapper data={data}>
			{(liveProps) => liveProps && <BlockComponent {...props} {...liveProps} />}
		</LivePreviewWrapper>;
